module.exports = __webpack_public_path__ + "static/media/ar-upload.defa9391.svg";